import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* <div className="footer-left">
          <h3>Nistha</h3>
          
        </div> */}
      </div>
      <div className="footer-bottom">
        <p>&copy; 2024 Nistha Bajracharya</p>
      </div>
    </footer>
  );
};

export default Footer;
